<template>
    <figure class="flex flex-col gap-4">
        <div class="flex items-center justify-center gap-[10px]">
            <v-icon icon="account-circle"></v-icon>
            <div class="text-body-medium-button text-black-78">
                Osebni podatki
            </div>
        </div>
        <ul class="flex flex-col gap-8">
            <li>
                <v-select
                    class="v-select--xs w-full appearance-none rounded-full border-0 p-0 font-medium text-black-78 ring-1 ring-inset ring-gray placeholder:text-black-40 focus-within:ring-2 focus-within:ring-green"
                    :options="customerFormEnums.title"
                    placeholder="Naziv"
                    v-model="customerPrefix"
                    label="label"
                    ref="prefix"
                    id="prefix"
                    :name="'prefix'"
                >
                    <template v-slot:no-options>
                        Za ta iskalni niz ni zadetkov.
                    </template>
                </v-select>
                <input
                    type="hidden"
                    name="title"
                    :value="customerPrefix == null ? '' : customerPrefix.value"
                />
                <template v-if="validationErrors.title">
                    <label class="small-text-medium text-red-500">{{
                        validationErrors.title[0] ?? ""
                    }}</label>
                </template>
            </li>
            <li>
                <v-select
                    class="v-select--xs w-full appearance-none rounded-full border-0 p-0 font-medium text-black-78 ring-1 ring-inset ring-gray placeholder:text-black-40 focus-within:ring-2 focus-within:ring-green"
                    :options="customerFormEnums.professional_title"
                    placeholder="Strokovni naziv"
                    v-model="customerProfessionalTitle"
                    label="label"
                    ref="professional_title_prefix"
                    id="professional_title_prefix"
                    :name="'professional_title_prefix'"
                >
                    <template v-slot:no-options>
                        Za ta iskalni niz ni zadetkov.
                    </template>
                </v-select>
                <input
                    type="hidden"
                    name="professional_title"
                    :value="customerProfessionalTitle == null ? '' : customerProfessionalTitle.value"
                />
                <template v-if="validationErrors.professional_title">
                    <label class="small-text-medium text-red-500">{{
                        validationErrors.professional_title[0] ?? ""
                    }}</label>
                </template>
            </li>
            <li>
                <v-form-input
                    id="userFirstName"
                    label="Ime"
                    type="text"
                    name="name"
                    :required="true"
                    :value="old.name ? old.name : user.name"
                ></v-form-input>
                <template v-if="validationErrors.name">
                    <label class="small-text-medium text-red-500">{{
                        validationErrors.name[0] ?? ""
                    }}</label>
                </template>
            </li>
            <li>
                <v-form-input
                    id="userLastName"
                    label="Priimek"
                    type="text"
                    name="last_name"
                    :required="true"
                    :value="old.last_name ? old.last_name : user.last_name"
                ></v-form-input>
                <template v-if="validationErrors.last_name">
                    <label class="small-text-medium text-red-500">{{
                        validationErrors.last_name[0] ?? ""
                    }}</label>
                </template>
            </li>
            <li>
                <v-datepicker
                    v-model="birth_date"
                    :formatter="dateFormatter"
                    id="userBirth"
                    name="birth_date"
                    placeholder="Datum rojstva"
                    as-single
                    input-classes="block w-full appearance-none rounded-full border-0 p-0 text-black-78 ring-1 ring-inset ring-gray placeholder:text-black-40 focus-within:ring-2 focus-within:ring-green px-5 py-4 text-form"
                />
                <template v-if="validationErrors.birth_date">
                    <label class="small-text-medium text-red-500">{{
                        validationErrors.birth_date[0] ?? ""
                    }}</label>
                </template>
            </li>
        </ul>
    </figure>
</template>

<script>
import VueTailwindDatepicker from "vue-tailwind-datepicker";
export default {
    components: {
        "v-datepicker": VueTailwindDatepicker,
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
        old: {
            type: Object,
            required: true,
        },
        customerFormEnums: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
        },
    },
    mounted() {
        // On load preset dropdwon values
        this.customerFormEnums.title.forEach((element) => {
            if(this.old && 'title' in this.old) {
                if(this.old.title == element.value) {
                    this.customerPrefix = element;
                }
            } else {
                if(element.value == this.user.title) {
                    this.customerPrefix = element
                }
            }
        })

        this.customerFormEnums.professional_title.forEach((element) => {
            if(this.old && 'professional_title' in this.old) {
                if(this.old.professional_title == element.value) {
                    this.customerProfessionalTitle = element;
                }
            } else {
                if(element.value == this.user.professional_title) {
                    this.customerProfessionalTitle = element
                }
            }
        })

        this.birth_date = (this.old && 'birth_date' in this.old) ? this.old.birth_date : this.user.birth_date_formatted
    },
    data() {
        return {
            customerPrefix: null,
            customerProfessionalTitle: null,
            birth_date: null,
            dateFormatter: {
                date: 'D.M.YYYY',
                month: 'MMM'
            },
            //dateFormatter: (date) => date.toLocaleDateString(), // Assuming a simple date formatter
        };
    },
};
</script>
